
import React from 'react';
import { Button, Spin, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import SelectPartner from "../../components/ui/SelectPartner"; // Import the new component

const GuestProfileModal = ({ visible, onClose, guest, loading, historicalStays }) => {
  const { t } = useTranslation();
  if (!guest) return null;

  const handleClose = () => {
    console.log('GuestProfileModal handleClose called, onClose type:', typeof onClose); // Debug log
    if (typeof onClose === 'function') {
      onClose();
    } else {
      console.warn('onClose is not a function');
    }
  };

  const stayColumns = [
    {
      title: t('booking_id'),
      dataIndex: 'booking_id',
      key: 'booking_id',
    },
    {
      title: t('check_in_date'),
      dataIndex: 'check_in_date',
      key: 'check_in_date',
      render: (date) => moment(date).format('DD MMM YYYY'),
    },
    {
      title: t('check_out_date'),
      dataIndex: 'check_out_date',
      key: 'check_out_date',
      render: (date) => moment(date).format('DD MMM YYYY'),
    },
    {
      title: t('room_type'),
      dataIndex: 'room_type',
      key: 'room_type',
    },
    {
  title: t('total_amount'),
  dataIndex: 'total_amount',
  key: 'total_amount',
  render: (amount) => {
    const numericAmount = Number(amount);
    return isNaN(numericAmount) ? '-' : `$${numericAmount.toFixed(2)}`;
  },
},

    {
      title: t('status'),
      dataIndex: 'status',
      key: 'status',
    },
  ];

  return (
    <div
      className={`modal custom-modal fade ${visible ? 'show d-block' : ''}`}
      id="guest_profile"
      role="dialog"
      style={{ display: visible ? 'block' : 'none', fontFamily: "'Roboto', sans-serif" }}
    >
      <div
        className="modal-dialog modal-lg"
        style={{ margin: 0, position: 'fixed', right: 0, height: '100vh', width: '60%' }}
        role="document"
      >
        <div className="modal-content h-100 d-flex flex-column">
          <div className="modal-header">
            <h5 className="modal-title" style={{ color: '#333', fontSize: '18px', fontWeight: 600 }}>
              {t('guest_profile')}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                console.log('Profile close button clicked (header)'); // Debug log
                handleClose();
              }}
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{
              position: 'relative',
              padding: '16px',
              overflowY: 'auto',
              flex: '1 1 auto',
              maxHeight: 'calc(100vh - 120px)', // Adjust for header (~60px) and footer (~60px)
            }}
          >
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: 'rgba(255, 255, 255, 0.8)',
                  zIndex: 10,
                }}
              >
                <Spin size="large" />
              </div>
            )}
            <div className="card shadow-sm border-0" style={{ opacity: loading ? 0.5 : 1 }}>
              <div className="card-body">
                {/* Personal Information */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('personal_information')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('guest_title')}</label>
                    <p className="form-control form-input">{guest.guest_title || 'N/A'}</p>
                    <label className="form-label">{t('full_name')}</label>
                    <p className="form-control form-input">{guest.full_name}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('gender')}</label>
                    <p className="form-control form-input">{guest.gender || 'N/A'}</p>
                    <label className="form-label">{t('date_of_birth')}</label>
                    <p className="form-control form-input">{guest.date_of_birth ? moment(guest.date_of_birth).format('DD MMM YYYY') : 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('nationality')}</label>
                    <p className="form-control form-input">{guest.nationality}</p>
                    <label className="form-label">{t('guest_id')}</label>
                    <p className="form-control form-input">{guest.guest_id}</p>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('contact_information')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('phone_number')}</label>
                    <p className="form-control form-input">{guest.phone_no || 'N/A'}</p>
                    <label className="form-label">{t('email')}</label>
                    <p className="form-control form-input">{guest.email || 'N/A'}</p>
                  </div>
                </div>

                {/* Address Information */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('address_information')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('address')}</label>
                    <p className="form-control form-input full-width">{guest.address || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('country')}</label>
                    <p className="form-control form-input">{guest.country || 'N/A'}</p>
                    <label className="form-label">{t('state')}</label>
                    <p className="form-control form-input">{guest.state || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('city')}</label>
                    <p className="form-control form-input">{guest.city || 'N/A'}</p>
                    <label className="form-label">{t('zip_code')}</label>
                    <p className="form-control form-input">{guest.zip_code || 'N/A'}</p>
                  </div>
                </div>

                {/* Identity Information */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('identity_information')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('id_proof_type')}</label>
                    <p className="form-control form-input">{guest.id_proof_type}</p>
                    <label className="form-label">{t('id_proof_number')}</label>
                    <p className="form-control form-input">{guest.id_proof_number}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('is_authenticated')}</label>
                    <p className="form-control form-input">{guest.is_authenticated ? t('yes') : t('no')}</p>
                    <label className="form-label">{t('id_proof_issuing_authority')}</label>
                    <p className="form-control form-input">{guest.id_proof_issuing_authority || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('id_proof_file')}</label>
                    <p className="form-control form-input">
                      {guest.id_proof_file ? <a href={guest.id_proof_file} target="_blank" rel="noopener noreferrer">{t('view_file')}</a> : 'N/A'}
                    </p>
                    <label className="form-label">{t('passport_number')}</label>
                    <p className="form-control form-input">{guest.passport_number || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('passport_expiry')}</label>
                    <p className="form-control form-input">{guest.passport_expiry ? moment(guest.passport_expiry).format('DD MMM YYYY') : 'N/A'}</p>
                    <label className="form-label">{t('visa_number')}</label>
                    <p className="form-control form-input">{guest.visa_number || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('visa_expiry')}</label>
                    <p className="form-control form-input">{guest.visa_expiry ? moment(guest.visa_expiry).format('DD MMM YYYY') : 'N/A'}</p>
                  </div>
                </div>

                {/* GST Information */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('gst_information')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('gst_number')}</label>
                    <p className="form-control form-input">{guest.gst_number || 'N/A'}</p>
                    <label className="form-label">{t('gst_company_name')}</label>
                    <p className="form-control form-input">{guest.gst_company_name || 'N/A'}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('gst_company_address')}</label>
                    <p className="form-control form-input full-width">{guest.gst_company_address || 'N/A'}</p>
                  </div>
                </div>

                {/* Guest Status */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('guest_status')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('is_regular')}</label>
                    <p className="form-control form-input">{guest.is_regular ? t('yes') : t('no')}</p>
                    <label className="form-label">{t('company_id')}</label>
                    <p className="form-control form-input">{guest.companyid}</p>
                  </div>
                  <div className="form-row">
                    <label className="form-label">{t('created_at')}</label>
                    <p className="form-control form-input">{moment(guest.created_at).format('DD MMM YYYY, HH:mm')}</p>
                    <label className="form-label">{t('updated_at')}</label>
                    <p className="form-control form-input">{moment(guest.updated_at).format('DD MMM YYYY, HH:mm')}</p>
                  </div>
                </div>

                {/* Historical Stay */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('historical_stay')}</h5>
                  <Table
                    columns={stayColumns}
                    dataSource={historicalStays || []}
                    rowKey="booking_id"
                    pagination={false}
                    bordered
                    style={{ fontSize: '14px' }}
                    className="daybook-table"
                  />
                </div>

                {/* Additional Guests */}
                <div className="mb-4">
                  <h5 className="text-primary mb-3 section-title">{t('additional_guests')}</h5>
                  <div className="form-row">
                    <label className="form-label">{t('additional_guests')}</label>
                    <p className="form-control form-input full-width">
                      {guest.additional_guests && guest.additional_guests.length > 0
                        ? guest.additional_guests.map((ag) => `${ag.name} (${ag.relation})`).join(', ')
                        : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-center" style={{ padding: '10px', borderTop: '1px solid #dee2e6', background: '#fff' }}>
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                console.log('Profile close button clicked (footer)'); // Debug log
                handleClose();
              }}
              disabled={loading}
              style={{ borderColor: '#666', color: '#666' }}
            >
              {t('close')}
            </Button>
          </div>
        </div>
      </div>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

        .modal-content {
          border: 1px solid #dee2e6;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .modal-header {
          background: #fff;
          border-bottom: 1px solid #dee2e6;
          padding: 12px 16px;
        }
        .modal-title {
          font-size: 18px;
          font-weight: 600;
        }
        .modal-body {
          padding: 16px;
          background: #fff;
        }
        .modal-footer {
          border-top: 1px solid #dee2e6;
          background: #fff;
          padding: 10px;
        }
        .btn-close {
          font-size: 16px;
          color: #666;
        }
        .form-row {
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #e9ecef;
        }
        .form-row:last-child {
          border-bottom: none;
        }
        .form-label {
          width: 150px;
          margin-bottom: 0;
          font-weight: 500;
          color: #495057;
        }
        .form-input {
          flex: 1;
          margin-right: 20px;
        }
        .form-input:last-child {
          margin-right: 0;
        }
        .section-title {
          border-bottom: 2px solid #007bff;
          padding-bottom: 5px;
          margin-bottom: 20px;
        }
        .full-width {
          flex: unset;
          width: 100%;
        }
        .form-control {
          font-size: 14px;
          padding: 8px 12px;
          height: 38px;
          border-radius: 4px;
          background: #f8f9fa;
          border-color: #dee2e6;
        }
        a {
          color: #007bff;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }
        .daybook-table .ant-table-thead > tr > th {
          background: #ffffff;
          font-weight: 600;
          padding: 8px 16px;
          font-size: 14px;
        }
        .daybook-table .ant-table-tbody > tr > td {
          padding: 12px 18px;
          font-size: 14px;
          height: 60px;
        }
        .daybook-table .ant-table {
          border: 1px solid #dee2e6;
        }
        .daybook-table .ant-table-tbody > tr.ant-table-row:hover > td {
          background: #f5f5f5;
        }
      `}</style>
    </div>
  );
};

export default GuestProfileModal;